import LazyVideoComponent from "@components/LandingPageComponents/LazyVideoComponent";
import React from "react";

interface ArabicVideoSectionProps {
    botIconSrc: string;
}

const ArabicVideoSection: React.FC<ArabicVideoSectionProps> = (props) => {
    const { botIconSrc } = props;
    return (
        <header className=" lg:px-0 px-4 lg:pt-20 pt-0 mx-auto max-w-6xl ">
            <div className="flex flex-col lg:flex-row justify-center md:justify-between">
                <div className="lg:w-1/2 gap-1 flex flex-col my-10">
                    <span className=" max-w-lg lg:text-left mt-4 text-right">
                        <h2 className="lg:text-4xl lg:px-0 px-4 lg:leading-tight leading-normal text-3xl font-bold text-right">
                            عزز الثقة وقم بزيادة الإيرادات من خلال المحادثات المدعومة بالذكاء
                        </h2>
                        <div className="lg:text-lg text-md font-normal  w-full pb-8 text-right">
                            تجاوز عالم القوالب القياسية واترك انطباعًا دائمًا لدى عملائك المحتملين والدائمين بفضل قوة التخصيص بمساعدة الذكاء الاصطناعي
                        </div>
                        <div className="lg:text-lg text-md font-normal space-y-4 pt-5 text-right">
                            <div className="flex items-center justify-end">
                                <div>احصل على مساعدة الخبراء من الذكاء الاصطناعي الذي يمكن الاعتماد عليه</div>
                                <div className="mr-2 w-6 h-6 pl-2">
                                    <img
                                        loading="lazy"
                                        src="https://assets.gallabox.com/gb-home/content-with-image/green-tick-circle.svg"
                                        alt="Green Checkmark"
                                        className="w-full h-full"
                                    />
                                </div>
                            </div>
                            <div className="flex items-center justify-end">
                                <div>رد على العملاء بلغتهم الأم</div>
                                <div className="mr-2 w-6 h-6 pl-2">
                                    <img
                                        loading="lazy"
                                        src="https://assets.gallabox.com/gb-home/content-with-image/green-tick-circle.svg"
                                        alt="Green Checkmark"
                                        className="w-full h-full"
                                    />
                                </div>
                            </div>
                            <div className="flex items-center justify-end">
                                <div>قم بتقسيم المصطلحات الفنية إلى رسائل بسيطة</div>
                                <div className="mr-2 w-6 h-6 pl-2">
                                    <img
                                        loading="lazy"
                                        src="https://assets.gallabox.com/gb-home/content-with-image/green-tick-circle.svg"
                                        alt="Green Checkmark"
                                        className="w-full h-full"
                                    />
                                </div>
                            </div>
                        </div>
                    </span>
                    <div className="flex flex-col pt-4 lg:pt-0 md:flex-row gap-4 justify-center md:justify-start mx-12 md:mx-0"></div>
                </div>

                <div className="lg:w-1/2 h-full w-full pt-10 lg:pt-10  ">
                    <LazyVideoComponent src={botIconSrc} type="video/mp4" poster="https://assets.gallabox.com/gb-home/ai/lazy-img.png" />
                </div>
            </div>
        </header>
    );
};

export default ArabicVideoSection;
